export default import.meta.ROLLDOWN_FILE_URL_P4DPfwIRieI8P6q8r4JZRw_05551c3c1a2d7ecb9a4dea40